import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { FileText, ArrowRight, Rss, Clock, Tag, Calendar } from "lucide-react";
import { SeoHead } from "../../seo/SeoHead";
import { buildBreadcrumbListJsonLd } from "../../seo/site";
import { blogPosts } from "../../content/blog/posts";

const SEO_DESCRIPTION =
  "Blog Raguia : guides pratiques sur l'IA documentaire pour PME françaises. RAG, RGPD, OCR, chatbot sur vos documents. Conseils pour cabinets RH, avocats, immobilier.";



export default function BlogPage() {
  return (
    <>
      <SeoHead
        title="Blog Raguia — IA documentaire pour PME françaises"
        description={SEO_DESCRIPTION}
        jsonLd={buildBreadcrumbListJsonLd([
          { name: "Accueil", path: "/" },
          { name: "Blog", path: "/blog" },
        ])}
      />
      <main className="min-h-screen bg-stone-50">
        {/* HERO */}
        <section className="relative px-4 pt-16 pb-12 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden">
          <div className="absolute top-0 right-0 size-96 bg-[#A43032]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full border-2 border-[#A43032]/30 bg-[#A43032]/10 px-4 py-2 text-sm font-semibold text-[#A43032] mb-8">
              <Rss className="size-4" />
              Blog & Ressources
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-black tracking-tight text-[#010101] max-w-4xl leading-[1.1] mb-6">
              L'IA documentaire{" "}
              <span className="text-[#A43032]">expliquée simplement</span>
            </h1>
            <p className="text-lg md:text-xl text-stone-600 max-w-2xl font-medium">
              Guides pratiques, études de cas et conseils pour les PME françaises
              qui veulent tirer parti de l'IA sur leurs documents internes.
            </p>
          </div>
        </section>

        {/* ARTICLES RÉCENTS */}
        <section className="px-4 pb-16 sm:px-6 lg:px-8 max-w-7xl mx-auto">
          <div className="mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-[#010101] mb-2">
              Articles récents
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group rounded-2xl border-2 border-stone-200 overflow-hidden shadow-sm hover:border-[#A43032]/30 hover:shadow-md transition-all duration-300 flex flex-col"
              >
                <Card className="flex flex-1 border-0 shadow-none">
                  <CardContent className="p-6 flex flex-col flex-1">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex gap-2 items-center">
                        <span className="inline-flex items-center gap-1.5 rounded-full bg-[#A43032]/10 border border-[#A43032]/20 px-3 py-1 text-xs font-bold text-[#A43032]">
                          <Tag className="size-3" />
                          {post.tags?.[0]}
                        </span>
                        {post.tags?.length > 1 && (
                          <span className="text-[10px] text-stone-400 font-bold uppercase tracking-wider">+{post.tags.length - 1}</span>
                        )}
                      </div>
                      <span className="text-xs text-stone-400 font-medium flex items-center gap-1">
                        <Clock className="size-3" /> {post.readTime}
                      </span>
                    </div>
                    <h3 className="font-heading font-semibold text-[#010101] text-xl leading-tight mb-3 group-hover:text-[#A43032] transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-sm text-stone-600 leading-relaxed mb-6 flex-1">
                      {post.excerpt}
                    </p>
                    <div className="flex items-center justify-between pt-4 border-t border-stone-50">
                      <div className="flex items-center gap-2 text-xs text-stone-400 font-bold">
                        <Calendar className="size-3" />
                        {post.date}
                      </div>
                      <span className="text-xs font-bold text-[#A43032] flex items-center gap-1">
                        Lire la suite <ArrowRight className="size-3" />
                      </span>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </section>


      </main>
    </>
  );
}
